import { Search } from 'react-feather'

import { Row, Col, InputGroup, Input, InputGroupText } from 'reactstrap'

const ContractsSearchbar = (props) => {
    const { filterTemplates } = props

    return (
        <div id='ecommerce-searchbar' className='ecommerce-searchbar'>
            <Row className='mt-1'>
                <Col sm='12'>
                    <InputGroup className='input-group-merge'>
                        <Input
                            className='search-product'
                            placeholder='Search Product'
                            onChange={(event) => filterTemplates(event.target.value)}
                        />
                            <InputGroupText>
                            <Search className='text-muted' size={14} />
                        </InputGroupText>
                    </InputGroup>
                </Col>
            </Row>
        </div>
    )
}

export default ContractsSearchbar
